import { apiGet } from './client';
import type { Environment } from '../constants';
import { toSearchParams, type CostQuery, type CostResult } from '../costs/model';

export const getCosts = (
  environment: Environment,
  query: CostQuery,
): Promise<{ data: CostResult }> =>
  apiGet(environment, `/costs?${toSearchParams(query).toString()}`);
